import React from "react";
import { escapeRegex } from "../utils/string";

export const HighlightedText = (p: {
  children?: string;
  highlight?: string;
}) => {
  const matches = p.highlight?.toLocaleLowerCase()
    .split(" ")
    .map(f => f.trim())
    .filter(fragment =>
      fragment.length && p.children?.toLocaleLowerCase().includes(fragment)
    );

  const highlighted = p.children?.split(" ").flatMap((word, j) => {
    const match = matches?.find(m => word.toLocaleLowerCase().includes(m));
    if (!match) {
      return word + " ";
    }

    return (
      word.split(new RegExp(`(${escapeRegex(match)})`, "gi"))
        .map((fragment, i) =>
          fragment.toLocaleLowerCase() === match ? (
            <strong key={fragment + i + j} className="text-primary border">{fragment}</strong>
          ) : (
            fragment
          )
        )
        .concat(" ")
    );
  });

  return (
    <>
      {highlighted}
    </>
  )
}